import Container from '@anm/components/Container';
import TitleBlock, { TitleDescription } from '@anm/components/TitleBlock';
import Tooltip, { TooltipContent } from '@anm/components/Tooltip';
import Button from '@anm/components/buttons/Button';
import { flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const containerOnMobile = media.phone`
  padding: 0;
`;

export const ContainerWrapper = styled(Container)`
  ${containerOnMobile}
`;

const mainTitleOnMobile = media.phone`
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 0;
  }
`;

export const MainTitle = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 32px;
    font-weight: bold;
    line-height: 48px;
    margin: 20px 0 12px;
  }
  ${TitleDescription} {
    font-size: 18px;
    line-height: 32px;
    font-weight: normal;
    margin-bottom: 47px;
  }
  ${mainTitleOnMobile};
`;

export const SecondaryTitle = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    margin-bottom: 12px;
  }
  ${TitleDescription} {
    font-size: 16px;
    line-height: 25px;
    font-weight: normal;
  }
  a {
    color: rgb(43, 161, 201);
  }
`;

export const InputRow = styled.div`
  ${flexRow};
  margin: 32px 0 16px;
  ${TooltipContent} {
    top: 50px;
  }
`;

export const ChannelIdInput = styled.input`
  width: 400px;
  font-size: 16px;
  min-height: 50px;
  line-height: 25px;
  border-radius: 5px;
  padding: 12px 17px;
  margin-right: 20px;
  box-sizing: border-box;
  border: 1px solid #cbdce5;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
  &::placeholder {
    color: #919eab;
  }
  &:focus {
    outline: none;
    border-color: rgb(43, 161, 201);
  }
`;

const addButtonOnMobile = media.phone`
  padding: 0 20px;
  min-width: unset;
`;

export const AddChannelButton = styled(Button)<{ isButtonDisabled: boolean }>`
  min-width: 130px;
  pointer-events: ${({ isButtonDisabled }) => (isButtonDisabled ? 'none' : 'all')};
  ${addButtonOnMobile};
`;

export const ChannelRow = styled.div`
  width: 100%;
  height: 50px;
  color: #919eaa;
  font-size: 16px;
  cursor: pointer;
  line-height: 25px;
  position: relative;
  padding: 12px 17px;
  border-radius: 5px;
  &:hover {
    background: #f5f7fa;
    img {
      display: block;
    }
  }
  img {
    top: 50%;
    right: 16px;
    display: none;
    position: absolute;
    transform: translateY(-50%);
  }
`;

export const LoaderContainer = styled.div`
  margin-top: 40px;
`;

export const ClaimContent = styled.div`
  margin-top: 50px;
`;

export const ClaimResolveText = styled.p`
  span {
    cursor: pointer;
    color: rgb(43, 161, 201);
  }
`;

export const NotificationsWrapper = styled.div`
  p {
    word-break: break-word;
  }
`;

const tooltipOnMobile = media.phone`
  top: 60px;
`;

export const TooltipWrapper = styled(Tooltip)`
  top: 50px;
  min-width: 245px;
  ${tooltipOnMobile};
`;
